import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { usePresentationCreate } from '@/module/Author/Presentation/model/PresentationQuery';
import {
  PresentationSchema,
  defaultPresentationValues,
  presentationSchema,
} from '@/module/Author/Presentation/model/PresentationSchema';

import { useAppNotification } from '@feature/utils';

import { PresentationForm } from './PresentationForm';

export function PresentationCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = usePresentationCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: PresentationSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newPresentation => {
        notification.success();
        navigate({
          to: '/author/presentation/$presentationId',
          params: { presentationId: String(newPresentation.id) },
        });
      },
    });
  };

  return (
    <PresentationForm
      title={t('presentations.form.title.create')}
      schema={presentationSchema}
      defaultValues={defaultPresentationValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
